import React, { Component } from "react";

import {
  withGoogleMap,
  GoogleMap,
  withScriptjs,
  Marker
} from "react-google-maps";


class LocationSearchModal extends Component {


  state = {

    height: 400,

    zoom: 15,


    mapPosition: {

      lat: 32.088056,

      lng: 34.839444

    },


    markerPosition: {

      lat: 32.088056,

      lng: 34.839444

    }

  };





  onMarkerDragEnd = (event) => {


    const lat = event.latLng.lat();

    const lng = event.latLng.lng();



    this.setState({

      markerPosition: {

        lat,

        lng

      }

    });


  };





  render(){



    const AsyncMap = withScriptjs(

      withGoogleMap(

        () => (

          <GoogleMap


            defaultZoom={this.state.zoom}


            defaultCenter={{

              lat: this.state.mapPosition.lat,

              lng: this.state.mapPosition.lng

            }}


          >



            <Marker


              draggable={true}


              onDragEnd={this.onMarkerDragEnd}


              position={{

                lat: this.state.markerPosition.lat,

                lng: this.state.markerPosition.lng

              }}


              title="גרור אותי"



            />



          </GoogleMap>


        )

      )

    );





    return (

      <div className="map-wrapper">



        <AsyncMap


googleMapURL={
  "https://maps.googleapis.com/maps/api/js?key=AIzaSyC2H55uGYHc55B2L3CwQd2Jzijoj_isaU0&libraries=places"
}


          loadingElement={

            <div style={{height:"100%"}} />

          }



          containerElement={

            <div style={{

              height:this.state.height,

              width:"100%"

            }} />

          }



          mapElement={

            <div style={{

              height:"100%"

            }} />

          }



        />



      </div>

    );


  }



}


export default LocationSearchModal;